/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      // open taxonomy dropdowns
      $( document ).on( 'click', '.inventory .sidebar-col form li[data-sf-field-type="taxonomy"] h4', function() {
        $( this ).toggleClass( 'is-open' ).next().slideToggle();
      } );

      const $temp = $( '<input>' );
      const $url = $( location ).attr( 'href' );

      $( document ).on( 'click', '.share-me', function() {
        $( 'body' ).append( $temp );
        $temp.val( $url ).select();
        document.execCommand( 'copy' );
        $temp.remove();
        $( '.copy-over' ).text( 'URL copied!' );
      } );


      // allow vin to be one field
      $( document ).on( 'keyup', '.inventory .sidebar-col form .sf-field-post-meta-product_vin_stock_num input', function() {
        $( this ).closest( 'div' ).find( 'label:last-child input' ).val( $( this ).val() );
      } );

      // allow vin to be null
      $( '.sf-field-post-meta-product_vin_stock_num input' ).addClass( 'is-loaded' );
      if ( $( '.sf-field-post-meta-product_vin_stock_num input' ).val() == 0 ) {
        console.log( 'here' );
        $( '.sf-field-post-meta-product_vin_stock_num input' ).attr( 'name', oldName ).val( '' );
      }
      let oldName = '';
      $( document ).on( 'sf:ajaxstart', '.searchandfilter', function() {
        console.log( 'there' );
        if ( $( '.sf-field-post-meta-product_vin_stock_num input' ).val() == 0 ) {
          oldName = $( '.sf-field-post-meta-product_vin_stock_num input' ).attr( 'name' );
          $( '.sf-field-post-meta-product_vin_stock_num input' ).attr( 'name', 'empty' );
        }
      } );

      // Prevent flashing and whatnot
      $( document ).on( 'sf:ajaxfinish', '.searchandfilter', function() {
        $( '.sf-field-post-meta-product_vin_stock_num input' ).addClass( 'is-loaded' );
        $( '.inventory-inner' ).addClass( 'is-loaded' );
        $( '.inventory .sidebar-col form li[data-sf-field-type="taxonomy"] input[checked]' ).closest( 'li[data-sf-field-type="taxonomy"]' ).find( 'h4' ).addClass( 'is-open' ).next().show();
        if ( $( '.sf-field-post-meta-product_vin_stock_num input' ).val() == 0 ) {
          $( '.sf-field-post-meta-product_vin_stock_num input' ).attr( 'name', oldName ).val( '' );
        }
      } );

      // select new by default
      if ( $( 'input[name="_sft_ll_condition[]"][value="new"]' ).length && !getUrlParameter( '_sft_ll_condition' ) ) {
        if ( $( 'body[class*="tax-ll_body_model"]' ).length ) {
          console.log( 'tax-page' );
          $( '.sf-field-post-meta-product_vin_stock_num input' ).attr( 'name', 'empty' );
        }
        $( 'input[name="_sft_ll_condition[]"][value="new"]' ).trigger( 'click' ).prop( 'checked', true ).parent().addClass( 'sf-option-active' );
        // $( 'input[name="_sft_ll_body_model[]"][value="service-bodies"]' ).trigger( 'click' ).prop( 'checked', true ).parent().addClass( 'sf-option-active' );
      } else {
        $( '.inventory-inner' ).addClass( 'is-loaded' );
      }

      $( '.contact-request-inventory-information' ).on( 'click', function() {
        $( '#input_3_11' ).attr( 'value', $( this ).attr( 'data-inventory-stock-id' ) );
      } );

      function getUrlParameter( sParam ) {
        const sPageURL = window.location.search.substring( 1 );
        const sURLVariables = sPageURL.split( '&' );
        let sParameterName;
        let i;

        for ( i = 0; i < sURLVariables.length; i++ ) {
          sParameterName = sURLVariables[i].split( '=' );

          if ( sParameterName[0] === sParam ) {
            return sParameterName[1] === undefined ? true : decodeURIComponent( sParameterName[1] );
          }
        }
        return false;
      }

      /*
       * SINGLE
       */

      $( '.single-product' ).find( '.main-slider' ).slick( {
        dots: false,
        arrows: false,
        slidesToShow: 1,
        asNavFor: $( '.single-product' ).find( '.slider-navigation' )[0],
      } );

      $( '.single-product' ).find( '.slider-navigation' ).slick( {
        dots: false,
        arrows: false,
        slidesToShow: 5,
        asNavFor: $( '.single-product' ).find( '.main-slider' )[0],
      } );

      $( '.single-product' ).find( '.slider-navigation .slide button' ).on( 'click', function() {
        $( '.single-product' ).find( '.main-slider' ).slick( 'slickGoTo', parseInt( $( this ).parent().attr( 'data-slick-index' ) ) );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'inventory', COMPONENT );
} )( app );
